import {useEffect, useState} from "react";

/*
 * useTheme
 * - 라이트/다크 테마 상태를 localStorage('theme')에 저장/조회한다.
 * - 반환 시그니처 [theme, themeToggler] 는 기존과 동일(하위호환).
 * - [추가] 같은 탭 내 여러 컴포넌트 인스턴스가 동기화되도록 커스텀 이벤트('themechange')를 사용한다.
 *   (예: 헤더의 토글 버튼을 누르면 현재 열려있는 페이지 본문도 즉시 함께 반영)
 */
const useTheme = () => {
    const getInitial = () => {
        const prefersColorScheme = window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
        const localTheme = localStorage.getItem('theme');
        return localTheme || prefersColorScheme;
    };

    const [theme, setTheme] = useState(getInitial);

    const setMode = (mode) => {
        localStorage.setItem('theme', mode);
        // 같은 탭의 다른 useTheme 인스턴스에 즉시 전파
        window.dispatchEvent(new CustomEvent('themechange', {detail: mode}));
        setTheme(mode);
    };

    const themeToggler = () => {
        theme === 'light' ? setMode('dark') : setMode('light');
    };

    useEffect(() => {
        // 같은 탭: 커스텀 이벤트 / 다른 탭: storage 이벤트 로 동기화
        const onThemeChange = (e) => setTheme(e.detail);
        const onStorage = (e) => {
            if (e.key === 'theme' && e.newValue) setTheme(e.newValue);
        };
        window.addEventListener('themechange', onThemeChange);
        window.addEventListener('storage', onStorage);
        return () => {
            window.removeEventListener('themechange', onThemeChange);
            window.removeEventListener('storage', onStorage);
        };
    }, []);

    return [theme, themeToggler];
};

export default useTheme;
